import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, memo, useMemo } from "react";
import { BOARD_COVER_EDITOR_X_POSITION_CSS_VAR, BOARD_COVER_EDITOR_Y_POSITION_CSS_VAR } from "~/components/v2/components/board/board-cover/BoardCoverEditor";
export const BoardCover = /*#__PURE__*/ memo(/*#__PURE__*/ forwardRef((param, ref)=>{
    let { board } = param;
    var _board_coverImage;
    var _board_coverImage_region;
    const region = (_board_coverImage_region = (_board_coverImage = board.coverImage) === null || _board_coverImage === void 0 ? void 0 : _board_coverImage.region) !== null && _board_coverImage_region !== void 0 ? _board_coverImage_region : {
        top: 0,
        left: 0,
        width: 100,
        height: 100
    };
    const verticalPosition = useMemo(()=>{
        if (region.height >= 100) return 50; // Center if full height
        // Map region.top to a position percentage (0-100)
        return region.top / (100 - region.height) * 100;
    }, [
        region.height,
        region.top
    ]);
    const horizontalPosition = useMemo(()=>{
        if (region.width >= 100) return 50; // Center if full width
        // Map region.left to a position percentage (0-100)
        return region.left / (100 - region.width) * 100;
    }, [
        region.width,
        region.left
    ]);
    if (!board.coverImage) {
        return null;
    }
    return /*#__PURE__*/ _jsx("div", {
        className: "relative aspect-[5.5/1] max-h-[280px] w-full shrink-0 overflow-hidden rounded-8 bg-grey-6",
        children: /*#__PURE__*/ _jsx("img", {
            ref: ref,
            src: board.coverImage.url,
            alt: "Board cover image",
            className: "absolute inset-0 size-full object-cover",
            style: {
                objectPosition: "var(".concat(BOARD_COVER_EDITOR_X_POSITION_CSS_VAR, ", ").concat(horizontalPosition, "%) var(").concat(BOARD_COVER_EDITOR_Y_POSITION_CSS_VAR, ", ").concat(verticalPosition, "%)")
            }
        })
    });
}));
BoardCover.displayName = "BoardCover";
